import React from "react"

import styles from "./buttonSet.module.scss"

const ButtonSet = ({ render }) => (
  <div className={styles.buttonSet}>{render(styles)}</div>
)

export default ButtonSet
